<template>
  <div class="fund-dividends">
    <DividendsDetails class="section-margin">
      <MoreTitle title="分红派息" />
    </DividendsDetails>
    <FundSplit>
      <MoreTitle title="拆股并股" />
    </FundSplit>
  </div>
</template>

<script>
import DividendsDetails from '@/components/f10/behavior/DividendsDetails.vue'
import FundSplit from '@/components/f10/etf/FundSplit.vue'
import { sendMsg } from '@/plugins/msg'
export default {
  components: { DividendsDetails, FundSplit },
  created() {
    sendMsg({ event: 'setTitle', title: '分红送转' })
  }
}
</script>

<style></style>
